import { DeliveryMode, OrderMethod } from '../../../../../../../services/exports/Constants';

export default {
  title: 'Kestääkö tilaus pidempään/lyhyemmän aikaa?',
  text: {
    [OrderMethod.Pickup]:
      'Asiakas odottaa tilauksen olevan valmis noudettavaksi <strong>{{date}}</strong> klo <strong>{{time}}</strong><br/> Voit tarvittaessa muuttaa aikaa täällä.',
    [OrderMethod.OnSite]:
      'Asiakas odottaa tilauksen olevan valmis noudettavaksi <strong>{{date}}</strong> klo <strong>{{time}}</strong><br/> Voit tarvittaessa muuttaa aikaa täällä.',
    [OrderMethod.Delivery]: {
      [DeliveryMode.Internal]:
        'Asiakas odottaa tilauksen toimitusta <strong>{{date}}</strong> klo <strong>{{time}}</strong><br/> Voit tarvittaessa muuttaa aikaa täällä.',
      [DeliveryMode.External]: 'Kuljettaja saapuu noutamaan tilauksen klo <strong>{{time}}{{confidenceLabel}}</strong>',
    },
  },
  labels: {
    today: 'Tänään',
  },
  confidence_labels: {
    estimated: ' (arvioitu!)',
    confirmed: '',
  },
  buttons: {
    confirm_pickup: 'Vahvista uusi noutoaika',
    confirm_delivery: 'Vahvista uusi toimitusaika',
  },
  confirmation_modal: {
    description: 'Haluatko varmasti muuttaa ajan {{currentPickupTime}} ajaksi {{newPickupTime}}?',
    ok_button_text: 'Vahvista uusi aika',
    cancel_button_text: 'Ei, palauta alkuperäinen aika',
  },
};
